module.exports = __webpack_public_path__ + "img/PPC.205f8240.svg";